export enum InvoicePPRTypeEnum {
    DEPENSE = 'D',
    RECETTE = 'R'
}